function ThrowError() {
  throw Error("Error")

  return null
}

export default ThrowError
